import TabHeader from "../../tab/TabHeader";
import AlertsControls from "./AlertsControls";
import AlertsDetails from "./AlertsDetails";

export default function AlertsTab() {
    return <div >
        <TabHeader>
            <h2>Alerts</h2>
            <AlertsControls />
        </TabHeader>        
        <AlertsDetails />        
    </div>
}